import React from "react";
const Error = () => {
	return (
		<>
			404 page
		</>
	);
};

export default Error;